import { Button } from "@/components/common/Button";
import { Icon } from "@/components/common/icon/Icon";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

const NotFound = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="h-full flex items-center justify-center px-4 pt-6">
      <div className="w-full max-w-[24rem] rounded-2xl border border-divider bg-surface-primary p-6 flex flex-col items-center gap-6 text-center">
        <div className="w-14 h-14 rounded-full bg-secondary-fill flex items-center justify-center">
          <Icon type="x" className="w-6 h-6 fill-link" />
        </div>

        <div className="flex flex-col items-center gap-2">
          <p className="text-[2rem] leading-8 font-semibold text-text">404</p>
          <p className="text-[1.25rem] leading-7 font-semibold text-text">
            {t("network-page.no_data")}
          </p>
          <p className="text-[0.9375rem] leading-5 text-hint">
            This page does not exist or was moved.
          </p>
        </div>

        <Button
          onClick={() => navigate("/")}
          text={t("withdraw-page.to_main")}
          size="large"
          className="w-full"
        />
      </div>
    </div>
  );
};

export default NotFound;
